import { clsx } from "clsx";
import type { Ref, TextareaHTMLAttributes } from "react";

/** The field skin on a textarea (FRONTEND_DESIGN.md §4.2). */
export function Textarea({
  className,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement> & { ref?: Ref<HTMLTextAreaElement> }) {
  return (
    <textarea
      className={clsx(
        "kss-control kss-field w-full resize-y px-3 py-[9px] text-sm leading-[1.5] text-neutral-900 dark:text-neutral-100",
        className,
      )}
      {...props}
    />
  );
}
